import { ACCENT_PRESETS } from './theme';

export function AccentPicker({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  const preset = ACCENT_PRESETS.some((option) => option.value === value.toLowerCase());
  return (
    <fieldset className="accent-picker">
      <legend>Accent color</legend>
      <div className="accent-presets">
        {ACCENT_PRESETS.map((option) => (
          <button
            type="button"
            key={option.value}
            className={option.value === value.toLowerCase() ? 'selected' : ''}
            aria-label={option.name}
            aria-pressed={option.value === value.toLowerCase()}
            title={option.name}
            onClick={() => onChange(option.value)}
          >
            <span style={{ backgroundColor: option.value }} />
          </button>
        ))}
        <label className={!preset ? 'custom-accent selected' : 'custom-accent'}>
          <input
            type="color"
            value={value}
            aria-label="Custom accent color"
            onChange={(event) => onChange(event.target.value)}
          />
          <span>Custom</span>
        </label>
      </div>
    </fieldset>
  );
}
